import { InputHTMLAttributes } from 'react';
import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { Input, InputErrorText } from 'src/common/components/Input';

export type FormInputProps<T extends FieldValues> = UseControllerProps<T> &
  InputHTMLAttributes<HTMLInputElement>;

export const FormInput = <TFieldValues extends FieldValues>({
  name,
  className,
  ...props
}: FormInputProps<TFieldValues>) => {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({ name });

  return (
    <>
      <Input
        className={className}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />
      <InputErrorText>{error?.message}</InputErrorText>
    </>
  );
};
